export default __webpack_public_path__ + "static/media/metrics.470ead49.svg";